import { UserMarkup_addNote, UserMarkup_viewNote } from './UserMarkupPopup.locstring.json';
import showUserNote from './UserNotePopup';
import getSelectionInstance from '../utils/getSelectionInstance';
import { observer } from 'mobx-react-lite';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { MailIcons } from 'owa-mail-icons';
import { ClientItem } from 'owa-mail-store';
import React from 'react';

const styles = require('./UserMarkupPopup.scss');

export interface NoteOptionProps {
    target: IPoint | HTMLElement;
    selectedText: string;
    element: HTMLElement;
    item: ClientItem;
    isForExistingUserNote: boolean;
    selectionRange?: Range;
    selectionInstance?: number;
    destroyPopupDivCallback: () => void;
}

const NoteOption = observer(function NoteOption(props: NoteOptionProps) {
    const {
        target,
        selectedText,
        element,
        item,
        isForExistingUserNote,
        selectionRange,
        selectionInstance,
        destroyPopupDivCallback,
    } = props;

    const onShowNote = React.useCallback(() => {
        destroyPopupDivCallback();
        showUserNote(
            target,
            selectedText,
            element,
            item,
            isForExistingUserNote,
            !isForExistingUserNote
                ? getSelectionInstance(selectedText, element, selectionRange)
                : selectionInstance
        );
    }, [
        target,
        selectedText,
        element,
        item,
        isForExistingUserNote,
        selectionRange,
        selectionInstance,
        destroyPopupDivCallback,
    ]);

    return (
        <TooltipHost
            content={isForExistingUserNote ? loc(UserMarkup_viewNote) : loc(UserMarkup_addNote)}>
            <IconButton
                className={styles.UserMarkupPopupButton}
                iconProps={
                    isForExistingUserNote
                        ? { iconName: ControlIcons.View }
                        : { iconName: MailIcons.EditNote }
                }
                onClick={onShowNote}
            />
        </TooltipHost>
    );
});

export default NoteOption;
